import { DefaultValueConfig } from '@headless-workspace/config';
import { ObjectHelpers, ValueHelpers } from '@headless-workspace/utils';
import {
    BaseProductValue,
    CustomerBasketDTO,
    mapProductBrandData,
    mapProductPriceData,
    mapURLToImage,
    PromotionType,
    VipBrandsValue,
} from '../../../../src';

export type BasketProductValue = Readonly<
    BaseProductValue & {
        shadeId?: number;
        quantity: number;
        maxQuantity?: number;
        isPreOrderable?: boolean;
        releaseDate?: Date;
        isBonus: boolean;
        productId: string;
        pricePerUnit?: string;
        engraves?: {
            font?: string;
            line1?: string;
            line2?: string;
            line3?: string;
        }[];
    }
>;

export const mapBasketProduct = (
    dto: CustomerBasketDTO['products'][number],
    currency: string,
    vipBrands: VipBrandsValue,
): BasketProductValue => {
    return {
        id: dto.id,
        productId: dto.productId,
        name: dto.name,
        href: dto.url ?? DefaultValueConfig.href,
        description: dto.description ?? '',
        image: mapURLToImage(dto.imageURL) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder),
        shadeId: dto.shadeId,
        quantity: dto.quantity,
        maxQuantity: dto.maxQuantity ?? 0, // FIXME: should be optional ??
        priceBeforeDiscount: dto.formerPrice ?? 0,
        discountPercentage: ValueHelpers.mapOptional(dto.discountPercentage),
        isPreOrderable: dto.isPreOrderable,
        releaseDate: dto.releaseDate ? new Date(dto.releaseDate) : undefined,
        isBonus: dto.isBonus,
        promotion: dto.promotion as PromotionType,
        ...mapProductBrandData(dto, vipBrands),
        ...mapProductPriceData(dto, currency),
        pricePerUnit: dto.pricePerUnit,
        engraves: ValueHelpers.mapOptional(dto.engraves),
    };
};
